import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 15.1 16" {...props}>
      <title>{props.title || 'Play'}</title>
      <g>
        <path d="M14.5 8.9l-13 7c-.1.1-.3.1-.5.1s-.4 0-.5-.1c-.3-.2-.5-.5-.5-.9V1C0 .6.2.3.5.1c.3-.2.7-.2 1 0l13 7c.3.2.5.5.5.9.1.4-.1.7-.5.9" />
      </g>
    </Icon>
  )
}
